import { WebStorageKeyType } from "types/auth/auth";


export const getLocalStorage = (key: WebStorageKeyType) => {
  const itemStr = localStorage.getItem(key);

  if(!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if(item.expires && now.getTime() > item.expires) {
    removeLocalStorage(key);
    return null;
  }

  return item.value;
}

export const setLocalStorage = (key: WebStorageKeyType, value: string, exp?: number) => {
  const now = new Date();
  const item = exp ? { value: value, expires: now.getTime() + exp * 60 * 1000 * 1000} : { value: value }
  localStorage.setItem(key, JSON.stringify(item));
}

export const removeLocalStorage = (key: WebStorageKeyType) => {
  localStorage.removeItem(key);
}

export const getSessionStorage = (key: WebStorageKeyType) => {
  const itemStr = sessionStorage.getItem(key);

  if(!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if(item.expires && now.getTime() > item.expires) {
    removeSessionStorage(key);
    return null;
  }

  return item.value;
}

export const setSessionStorage = (key: WebStorageKeyType, value: string, exp?: number) => {
  const now = new Date();
  const item = exp ? { value: value, expires: now.getTime() + exp * 60 * 1000 * 1000} : { value: value }
  sessionStorage.setItem(key, JSON.stringify(item));
}

export const removeSessionStorage = (key: WebStorageKeyType) => {
  sessionStorage.removeItem(key);
}

export const logoutLocalStorage = () => {
  // removeLocalStorage(WEB_STORAGE_KEYS.KORINDO_SESSION_ID);
}